
import { BUSINESS_UNIT_METADATA } from '../../businessunit/model/business-unit.metadata';
import { EntityMetadata, GenericEntityMetadata, PropertyMetadata, RelationshipType, TemporalType, nullIfContainsNull } from '@scisys-uim/uim-common';


export class CostCentreMetadataBase extends GenericEntityMetadata {
  constructor() {
    super('CostCentre', {
      ccId: <PropertyMetadata> {
        name: 'ccId',
        type: 'string',
        plural: false,
        isIdentity: true,
        derived: false,
        required: false,
        readOnly: false,
        readable: true,
        writeable: true,
        length: 6,
        unique: false
      },
      businessUnit: <PropertyMetadata> {
        name: 'businessUnit',
        type: 'BusinessUnit',
        plural: false,
        isIdentity: false,
        derived: false,
        required: false,
        readOnly: false,
        readable: true,
        writeable: true,
        relationship: true,
        relationshipType: RelationshipType.ManyToOne,
        get relationshipEntityMetadata(): EntityMetadata {
          return BUSINESS_UNIT_METADATA;
        },
        byReference: true,
        unique: false
      },
      acronym: <PropertyMetadata> {
        name: 'acronym',
        type: 'string',
        plural: false,
        isIdentity: false,
        derived: false,
        required: false,
        readOnly: false,
        readable: true,
        writeable: true,
        length: 6,
        unique: false
      },
      closed: <PropertyMetadata> {
        name: 'closed',
        type: 'boolean',
        plural: false,
        isIdentity: false,
        derived: false,
        required: false,
        readOnly: false,
        readable: true,
        writeable: true,
        unique: false
      },
      createdBy: <PropertyMetadata> {
        name: 'createdBy',
        type: 'string',
        plural: false,
        isIdentity: false,
        derived: false,
        required: false,
        readOnly: false,
        readable: true,
        writeable: true,
        length: 255,
        unique: false
      },
      createdDate: <PropertyMetadata> {
        name: 'createdDate',
        type: 'Date',
        temporalType: TemporalType.TIMESTAMP,
        plural: false,
        isIdentity: false,
        derived: false,
        required: false,
        readOnly: false,
        readable: true,
        writeable: true,
        unique: false
      },
      lockVersion: <PropertyMetadata> {
        name: 'lockVersion',
        type: 'number',
        plural: false,
        isIdentity: false,
        derived: true,
        required: false,
        readOnly: false,
        readable: true,
        writeable: true,
        unique: false
      },
      name: <PropertyMetadata> {
        name: 'name',
        type: 'string',
        plural: false,
        isIdentity: false,
        derived: false,
        required: true,
        readOnly: false,
        readable: true,
        writeable: true,
        length: 40,
        unique: false
      },
      type: <PropertyMetadata> {
        name: 'type',
        type: 'string',
        plural: false,
        isIdentity: false,
        derived: false,
        required: false,
        readOnly: false,
        readable: true,
        writeable: true,
        length: 1,
        unique: false
      },
      updatedBy: <PropertyMetadata> {
        name: 'updatedBy',
        type: 'string',
        plural: false,
        isIdentity: false,
        derived: false,
        required: false,
        readOnly: false,
        readable: true,
        writeable: true,
        length: 255,
        unique: false
      },
      updatedDate: <PropertyMetadata> {
        name: 'updatedDate',
        type: 'Date',
        temporalType: TemporalType.TIMESTAMP,
        plural: false,
        isIdentity: false,
        derived: false,
        required: false,
        readOnly: false,
        readable: true,
        writeable: true,
        unique: false
      }
    });
  }
  toKeyObject(item: any): any {
    const result = item?.ccId;
    return nullIfContainsNull(result);
  }
}



